import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey:            "AIzaSyBIV8Mabz2Uv-vo33SM68zeIUFl-WMQRII",
  authDomain:        "guffgaff-9a6b2.firebaseapp.com",
  projectId:         "guffgaff-9a6b2",
  storageBucket:     "guffgaff-9a6b2.firebasestorage.app",
  messagingSenderId: "416925521745",
  appId:             "1:416925521745:web:7149a13b8d5f9d25cb2570",
  measurementId:     "G-MJMKDTE25H",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
